import "./index.scss";

// Scelta a pulsanti per filtri e viste: options [{value, label, count}]
export default function ChoiceChips({options, value, onChange}) {
	return (
		<div className="choice-chips">
			{options.map((o) => (
				<button
					key={o.value}
					type="button"
					className={"choice-chip" + (o.value === value ? " is-active" : "")}
					aria-pressed={o.value === value}
					onClick={() => onChange(o.value)}
				>
					{o.label}
					{o.count !== undefined && (
						<span className="choice-chip__count">{o.count}</span>
					)}
				</button>
			))}
		</div>
	);
}
